module.exports = __webpack_public_path__ + "img/logo.46a998bc.png";